
import { useContext, useState } from 'react';
import KhAlert from '../../../Components/Alert/KhAlert';
import { UserInfokh } from '../../../Contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ApiURL } from '../../../App';

const AddCheckEmpolyee = () => {

  const queryParameters = new URLSearchParams(window.location.search);  // to get employeeId form url
    const employeeId = queryParameters.get("Id"); 
  
    const userInfo_Now =useContext(UserInfokh);
    const [alert_,SetAlert]=useState({Activate:false,msg:''});
    const [flag,Setflag]=useState(false);
    const navigate =useNavigate();
    const [formData, setFormData] = useState({
        employeeId: employeeId,
        girlsCount: '',
        menCount  : '',
        normJobHCount: '',
        addJobHCount: '',
        reward:'',
        discount:'',
        paidWage:'',
        date: new Date().toISOString().split('T')[0],
        notes: ''
      });
   
      const handleChange = (name, value) => {
        setFormData({
          ...formData,
          [name]: value
        });        
      };

      const handleSubmit = async (e) => {
        Setflag(true);
        if(!(formData.date.length<1 ||formData.employeeId.length<1||formData.girlsCount.length<0
          ||formData.menCount.length<0 ||formData.normJobHCount.length<0||formData.addJobHCount.length<0
          ||formData.reward.length<0 ||formData.discount.length<0 ||formData.paidWage.length<0
        ))
        {
          let formDataSended = {... formData}
          if(formData.girlsCount.length<1)
          {
            formDataSended.girlsCount=0;
          }
          if(formData.menCount.length<1)
          {
            formDataSended.menCount=0;
          }
          if(formData.normJobHCount.length<1)
          {
            formDataSended.normJobHCount=0;
          }
          if(formData.addJobHCount.length<1)
          {
            formDataSended.addJobHCount=0;
          }
          if(formData.reward.length<1)
          {
            formDataSended.reward=0;
          }
          if(formData.discount.length<1)
          {
            formDataSended.discount=0;
          }
          if(formData.paidWage.length<1)
          {
            formDataSended.paidWage=0;
          }
        
          try {
          const res = await axios.post(ApiURL+'Employee/AddNewDailyCheck', formDataSended, {
            headers: {
              'Accept': 'text/plain',
              'Content-Type': 'application/json',
               'Authorization': `bearer ${userInfo_Now.auth.token}`
            }
           
          });
          navigate('/AllEmployees');
          navigate(0)
          
        } catch (error) {      
          SetAlert({Activate:true,msg:'تأكد من الاتصال بالانترنت'});
         
        }
        }
      };

      //#region OnWheel Prevent Change
    const numberInputOnWheelPreventChange = (e) => {
      // Prevent the input value change
      e.target.blur()
    
      // Prevent the page/container scrolling
      e.stopPropagation()
    
      // Refocus immediately, on the next tick (after the current function is done)
      setTimeout(() => {
        e.target.focus()
      }, 0)
    }
    //#endregion

    return (
        <>
         <KhAlert Kh_Active={alert_.Activate} msg={alert_.msg} func_setactive={SetAlert} />
            <div className='parent-Dmaterial'>
                <div className='child-Dmaterial'>
                <div className="mb-3">
              <label className="form-label">
                التاريخ
              </label>
              <input
                className="form-control"
                type="date"
                name="date"
                value={formData.date}
                onChange={(e)=>{handleChange('date',e.target.value)}}
              />
               {formData.date.length<1 &&flag&& ( <p className="validationReg"> *الرجاء تحديد التاريخ</p>)}
            </div>

                <div className="mb-3"> 
              <label className="form-label">
              عدد العمال الشباب  
              </label>
              <input
                className="form-control"
                type='number'
                name="menCount"
                value={formData.menCount}
                onChange={(e)=>{handleChange('menCount',e.target.value)}}
                min={0}
							/>
              {formData.menCount.length<0 &&flag&& ( <p className="validationReg"> *الرجاء إدخال عدد الشباب </p>)}
            </div>
            <div className="mb-3"> 
              <label className="form-label">
              عدد العاملات   
              </label>
              <input
                className="form-control"
                type="number"
                name="girlsCount"
                value={formData.girlsCount}
                onChange={(e)=>{handleChange('girlsCount',e.target.value)}}
                min={0}
                onWheel={numberInputOnWheelPreventChange}
            />
               {formData.girlsCount.length<0 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
               </div>
           
            <div className="mb-3"> 
              <label className="form-label">
             عدد ساعات العمل الطبيعي
              </label>
              <input
                className="form-control"
                type="number"
                name="normJobHCount"
                value={formData.normJobHCount}
                onChange={(e)=>{handleChange('normJobHCount',e.target.value)}}
                min={0}
                onWheel={numberInputOnWheelPreventChange}
              />
             {formData.normJobHCount.length<0 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
            </div>
                
            <div className="mb-3"> 
              <label className="form-label">
             عدد ساعات العمل اإضافي
              </label>
              <input
                className="form-control"
                type="number"
                name="addJobHCount"
                value={formData.addJobHCount}
                onChange={(e)=>{handleChange('addJobHCount',e.target.value)}}
                min={0}
                onWheel={numberInputOnWheelPreventChange}
              />
             {formData.addJobHCount.length<0 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
            </div>
            <div className="mb-3"> 
              <label className="form-label">
             أجار سرفيس
              </label>
              <input
                className="form-control"
                type="number"
                name="reward"
                value={formData.reward}
                onChange={(e)=>{handleChange('reward',e.target.value)}}
                min={0}
                onWheel={numberInputOnWheelPreventChange}
              />
             {formData.reward.length<0 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
            </div>
            <div className="mb-3"> 
              <label className="form-label">
              الحسم
              </label>
              <input
                className="form-control"
                type="number"
                name="discount"
                value={formData.discount}
                onChange={(e)=>{handleChange('discount',e.target.value)}}
                min={0}
                onWheel={numberInputOnWheelPreventChange}
              />
             {formData.discount.length<0 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
            </div>
            <div className="mb-3"> 
              <label className="form-label">
              دفع الأجر حاليا
              </label>
              <input
                className="form-control"
                type="number"
                name="paidWage"
                value={formData.paidWage}
                onChange={(e)=>{handleChange('paidWage',e.target.value)}}
                min={0}
                onWheel={numberInputOnWheelPreventChange}
              />
             {formData.paidWage.length<0 &&flag&& ( <p className="validationReg"> *الرجاء إدخال قيمة هنا   </p>)}
            </div>
           
           
            <div className="mb-3">
                <label className="form-label">
                ملاحظات
                </label>
                <textarea 
                type='text'
                className="form-control"
                name="notes" 
                value={formData.notes} 
                onChange={(e)=>{handleChange('notes',e.target.value)}}
                placeholder={"إضافة ملاحظات..."}               
                />
              
            </div>
       
        <button className='btn-Add' onClick={()=>{handleSubmit()}} >إضافة</button>
                </div>
            </div>
            
        </>
    );
}

export default AddCheckEmpolyee;
